var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg39 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "39")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M86.5,44.83c.07,4.93-3.4,10.08-9.32,10.09-7.17,0-14.35,0-21.52,0-1,0-1,0-1,1,0,7.09-.06,14.18,0,21.27.08,7.71-9.3,12.73-15.51,7.88-3.14-2.45-3.56-6-3.55-9.7,0-6.59,0-13.18,0-19.76,0-.58-.18-.69-.71-.69-7.18,0-14.35,0-21.53,0a9.22,9.22,0,0,1-8.08-4.12,9.33,9.33,0,0,1,.22-11.07,9.31,9.31,0,0,1,7.92-3.84c7.16,0,14.31,0,21.47,0,.54,0,.71-.11.71-.69,0-7.16,0-14.31,0-21.47a9.27,9.27,0,0,1,3.09-7.31A9.63,9.63,0,0,1,54.55,12a8.07,8.07,0,0,1,.1,1.57q0,10.82,0,21.65c0,.58.13.75.73.74H68.52c3.79,0,8.2-.61,11.85.56A8.56,8.56,0,0,1,86.5,44.83Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg39, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/39.eee717e1.svg";
export { ForwardRef as ReactComponent };